import { ThemeColors, ThemeType } from "../types";

export const getThemeColors = (theme: ThemeType): ThemeColors => {
  switch (theme) {
    case "red":
      return {
        glow: "bg-rose-500",
        text: "text-rose-400",
        bgSoft: "bg-rose-50",
        textMain: "text-rose-600",
        border: "border-rose-100",
        accent: "bg-rose-500",
        shadow: "shadow-rose-500/50",
        borderAccent: "border-l-rose-300",
        borderAccentStrong: "border-l-rose-500",
      };
    case "amber":
      return {
        glow: "bg-amber-500",
        text: "text-amber-400",
        bgSoft: "bg-amber-50",
        textMain: "text-amber-600",
        border: "border-amber-100",
        accent: "bg-amber-500",
        shadow: "shadow-amber-500/50",
        borderAccent: "border-l-amber-300",
        borderAccentStrong: "border-l-amber-500",
      };
    case "blue":
      return {
        glow: "bg-blue-500",
        text: "text-blue-400",
        bgSoft: "bg-blue-50",
        textMain: "text-blue-600",
        border: "border-blue-100",
        accent: "bg-blue-500",
        shadow: "shadow-blue-500/50",
        borderAccent: "border-l-blue-300",
        borderAccentStrong: "border-l-blue-500",
      };
    case "emerald":
      return {
        glow: "bg-emerald-500",
        text: "text-emerald-400",
        bgSoft: "bg-emerald-50",
        textMain: "text-emerald-600",
        border: "border-emerald-100",
        accent: "bg-emerald-500",
        shadow: "shadow-emerald-500/50",
        borderAccent: "border-l-emerald-300",
        borderAccentStrong: "border-l-emerald-500",
      };
    default:
      return {
        glow: "bg-slate-500",
        text: "text-slate-400",
        bgSoft: "bg-slate-50",
        textMain: "text-slate-600",
        border: "border-slate-100",
        accent: "bg-slate-500",
        shadow: "shadow-slate-500/50",
        borderAccent: "border-l-slate-300",
        borderAccentStrong: "border-l-slate-500",
      };
  }
};

export const getHeaderGradient = (theme: ThemeType): string => {
  switch (theme) {
    case "red":
      return "from-rose-500 to-orange-500";
    case "amber":
      return "from-amber-400 to-orange-500";
    case "blue":
      return "from-blue-500 to-cyan-500";
    case "emerald":
      return "from-emerald-400 to-teal-500";
    default:
      return "from-slate-700 to-slate-900";
  }
};
